import React from 'react';
import { Instagram, MessageCircle } from 'lucide-react';

const WHATSAPP_LINK = 'https://wa.me/523312949249?text=Quiero%20mi%20menú%20digital%20para%20mi%20negocio';
const INSTAGRAM_LINK = 'https://www.instagram.com/zappien.ai?igsh=MWV3cWh0dW9ucnQ2aQ==';

export const BrandSection = () => (
  <div className="lg:col-span-2">
    <span className="text-2xl font-bold text-foreground block mb-4" style={{ fontFamily: 'Saira, sans-serif' }}>
      ZAPPIEN AI
    </span>
    <p className="text-sm text-muted-foreground max-w-md mb-6">
      Menús digitales inteligentes que convierten cada visita en más ventas. Diseñados para restaurantes que quieren crecer.
    </p>
    <div className="flex items-center gap-4">
      <a
        href={INSTAGRAM_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
      >
        <Instagram className="w-5 h-5" />
        @zappien.ai
      </a>
    </div>
  </div>
);

export const QuickLinks = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div>
      <h3 className="font-semibold mb-4">Navegación</h3>
      <ul className="space-y-3">
        <li>
          <button
            onClick={() => scrollToSection('benefits')}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Beneficios
          </button>
        </li>
        <li>
          <button
            onClick={() => scrollToSection('pricing')}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Planes
          </button>
        </li>
        <li>
          <button
            onClick={() => scrollToSection('faq')}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            FAQ
          </button>
        </li>
      </ul>
    </div>
  );
};

export const ContactSection = () => (
  <div>
    <h3 className="font-semibold mb-4">Contacto</h3>
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
    >
      <MessageCircle className="w-5 h-5" />
      WhatsApp
    </a>
  </div>
);

export const SocialLinks = () => (
  <div className="flex items-center gap-2">
    <a
      href={INSTAGRAM_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="p-2 rounded-lg hover:bg-secondary transition-colors"
    >
      <Instagram className="w-5 h-5 text-muted-foreground hover:text-primary transition-colors" />
    </a>
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="p-2 rounded-lg hover:bg-secondary transition-colors"
    >
      <MessageCircle className="w-5 h-5 text-muted-foreground hover:text-primary transition-colors" />
    </a>
  </div>
);
